module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [(!_vm.embedded) ? _c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("外管工作台")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("主管管理")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-title"
  }, [_vm._v("提醒规则")]), _vm._v(" "), (_vm.ruleLoading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('Form', {
    staticClass: "rule-form",
    attrs: {
      "label-width": 160,
      "show-message": false,
      "label-position": "right"
    }
  }, [_vm._l((_vm.fields), function(item) {
    return _c('Form-item', {
      key: item.key,
      attrs: {
        "label": item.label
      }
    }, [_c('InputNumber', {
      attrs: {
        "min": item.min,
        "max": item.max,
        "step": 1
      },
      model: {
        value: (_vm.form[item.key]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.key, $$v)
        },
        expression: "form[item.key]"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "unit"
    }, [_vm._v(_vm._s(item.unit))]), _vm._v(" "), _c('span', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(item.desc) + "（" + _vm._s(item.min) + "–" + _vm._s(item.max) + "）")])], 1)
  }), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "回访规则上线日"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "type": "date",
      "value": _vm.form.reviewStartDate,
      "clearable": false,
      "transfer": ""
    },
    on: {
      "on-change": function($event) {
        _vm.form.reviewStartDate = $event
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("入职日早于该日的老师不进回访清单，避免历史老师全部逾期")])], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.ruleSaving
    },
    on: {
      "click": _vm.saveRules
    }
  }, [_vm._v("保存规则")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.loadRules
    }
  }, [_vm._v("还原")])], 1)], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-title"
  }, [_vm._v("异动风险")]), _vm._v(" "), _c('p', {
    staticClass: "risk-note"
  }, [_vm._v("其余规则仍在「外教异动风险监测」的规则设置里。")]), _vm._v(" "), (_vm.riskLoading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('Form', {
    staticClass: "rule-form",
    attrs: {
      "label-width": 160,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "回溯月数"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 6,
      "max": 36,
      "step": 1
    },
    model: {
      value: (_vm.riskForm.lookbackMonths),
      callback: function($$v) {
        _vm.$set(_vm.riskForm, "lookbackMonths", $$v)
      },
      expression: "riskForm.lookbackMonths"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v("个月")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("6–36")])], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "异动线"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 1,
      "step": 1
    },
    model: {
      value: (_vm.riskForm.anomalyScore),
      callback: function($$v) {
        _vm.$set(_vm.riskForm, "anomalyScore", $$v)
      },
      expression: "riskForm.anomalyScore"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("风险分低于该线计入零瑕疵")])], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "高危线"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 1,
      "step": 1
    },
    model: {
      value: (_vm.riskForm.high),
      callback: function($$v) {
        _vm.$set(_vm.riskForm, "high", $$v)
      },
      expression: "riskForm.high"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("风险分达到该线为高危")])], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.riskSaving
    },
    on: {
      "click": _vm.saveRiskRules
    }
  }, [_vm._v("保存异动阈值")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.loadRiskRules
    }
  }, [_vm._v("还原")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-title"
  }, [_vm._v("\n      操作日志\n      "), _c('span', {
    staticClass: "block-desc"
  }, [_vm._v("最近 " + _vm._s(_vm.logLimit) + " 条")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "small",
      "icon": "refresh"
    },
    on: {
      "click": _vm.loadLogs
    }
  }, [_vm._v("刷新")])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.logColumns,
      "data": _vm.logList,
      "loading": _vm.logLoading,
      "stripe": "",
      "size": "small",
      "no-data-text": "暂无操作记录"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rule-bar"
  }, [_c('span', {
    staticClass: "rule-dot"
  }), _vm._v("\n    提醒规则保存后，工作台、试用期、新外教跟进、合同各页按新规则实时重算。异动的回溯月数、异动线、高危线在本页保存；其余规则仍在「外教异动风险监测」的规则设置里。\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bdae10aa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrWorkbench/HrWorkbenchSettings.vue
// module id = 1961
// module chunks = 8